import * as Yup from 'yup';
import { boolean, object, string } from 'yup';
import i18n from 'config/i18n';

import { ClientProtectedFragment } from 'api';

const required: string = i18n.t('common:required');
const acceptTermsError: string = i18n.t('auth:acceptTermsError');

export interface OnboardingCreateValues {
  full_name: string;
  acceptTerms: boolean;
}

export interface OnboardingIdentityValues {
  department_id: string;
  location_id: string;
}

export const OnboardingCreateSchema = object().shape({
  full_name: string().required(required),
  acceptTerms: boolean().oneOf([true], acceptTermsError),
});

export const OnboardingIdentitySchema = (client: ClientProtectedFragment) => {
  const locationValidation = client.locations_in_signup_required
    ? Yup.string().required(required)
    : Yup.string().nullable(true);

  const departmentValidation = client.departments_in_signup_required
    ? Yup.string().required(required)
    : Yup.string().nullable(true);

  return Yup.object().shape({
    location_id: locationValidation,
    department_id: departmentValidation,
  });
};
